export const search: object = {
  search: {
    sortBy: 'Sortierung nach:',
    mobileSortBy: 'Sortierung nach',
    enterKeyword: 'Stichwort eingeben',
    resultsFor: 'Ergebnisse für',
    noResults: 'Keine Produkte gefunden für',
    clearAll: 'Alle Zurücksetzen',
    placeholder: 'Suche nach Lösung, Publischer, Stichwor',
    facetSearchPlaceholder: 'Suche',
    searchSuggestions: 'Suchvorschläge',
    recentlySearched: 'Recently Searched',
    solutionSuggestions: 'Lösungsvorschläge',
    reset: 'Zurücksetzen',
    noSearchResults: {
      header: 'Es wurden leider keine Suchergebnisse gefunden',
      description: 'Vergewissern Sie sich, dass alle Wörter richtig geschrieben wurden, oder suchen Sie nach einem neuen Stichwort.'
    }
  },
};
